export var defaultProps = {
    duration: 3000,
    type: 'info',
    closeable: false,
};
